/**
 * Hero carousel slides, in display order.
 *
 * `image` is the basename under `/public/images`; each has an `.avif` (primary)
 * and `.jpg` (fallback). These three are the only 16:9 renders in the set,
 * which is what a full-bleed banner needs.
 */
export const HERO_SLIDES = [
  { image: 'hero-headquarters', altKey: 'hero.slides.headquarters' },
  { image: 'hero-energy', altKey: 'hero.slides.energy' },
  { image: 'hero-logistics', altKey: 'hero.slides.logistics' },
] as const

/**
 * The widths each hero render ships at, largest first. 1376 is the renders'
 * native width — there is nothing above it to upscale from.
 */
export const HERO_WIDTHS = [1376, 960] as const

/** How long each slide holds before the cross-fade, in milliseconds. */
export const SLIDE_INTERVAL_MS = 5000
